module.exports = __webpack_public_path__ + "static/media/sal-wood.929d0d3f.jpeg";